import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Pagination } from 'antd';
import { withRouter } from 'react-router-dom';
import qs from 'qs';

import { defaultPagination } from 'constants/defaults';

@withRouter
export default function withTablePagination(TableComponent) {
    return class extends Component {
        static propTypes = {
            pagination: PropTypes.object,
            handlePagination: PropTypes.func,
            history: PropTypes.object,
            location: PropTypes.object,
        };

        componentDidMount = () => {
            const { linesPerPage } = this.props.pagination || {};
            const { page, pageSize } = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });

            if (page && (linesPerPage || pageSize)) {
                this.props.handlePagination(page, pageSize || linesPerPage);
            }
        }

        handlePaginationVisible = (isScrollEnd) => {
            if (this.pagination) {
                this.pagination.classList.toggle('lv-pagination-show', isScrollEnd);
            }
        }

        getCurrentPage = (line, linesPerPage)  => {
            return (line - line % linesPerPage) / linesPerPage + 1;
        }

        replaceHistory = (page, pageSize) => {
            this.props.history.replace(qs.stringify({
                page,
                pageSize: pageSize !== defaultPagination.linesPerPage ? pageSize : undefined,
            }, { addQueryPrefix: true, strictNullHandling: true }));
        }

        handlePaginationWithScroll = (page, size) => {
            const pageSize = (this.props.pagination || {}).linesPerPage || size;
            this.replaceHistory(page, pageSize);
            this.props.handlePagination(page, pageSize);
            document.querySelector('.sticky-table-y-wrapper').scrollTop = 0;
        }

        handleShowSizeChange = (current, pageSize) => {
            this.replaceHistory(1, pageSize);
            this.props.handlePagination(1, pageSize);
            document.querySelector('.sticky-table-y-wrapper').scrollTop = 0;
        }

        render() {
            const { line, linesPerPage, linesTotal } = this.props.pagination || {};
            const hasPagination = linesTotal >= 10;

            return (
                <div className={cx('react-table-pagination', {'with-pagination': hasPagination})}>
                    <TableComponent { ...this.props } handlePaginationVisible={ this.handlePaginationVisible } />
                    { hasPagination &&
                        <div className="lv-pagination" ref={(node) => this.pagination = node}>
                            <Pagination
                                className="pagination"
                                defaultCurrent={1}
                                pageSize={linesPerPage}
                                total={linesTotal}
                                showSizeChanger={true}
                                current={this.getCurrentPage(line, linesPerPage)}
                                onShowSizeChange={this.handleShowSizeChange}
                                onChange={this.handlePaginationWithScroll}
                                showTitle={false}
                            />
                        </div>
                    }
                </div>
            );
        }
    };
}
